import React from 'react';
import Link from '../Link';
import styles from './Button.module.scss';

export default function Button(props) {
    const { className = '', children, style, type = 'button', disabled, href, onClick, primary, secondary, outline } = props;

    if (href) {
        return (
            <Link
                type={type}
                className={[className, styles.Button, primary ? styles.primary : '', secondary ? styles.secondary : '', outline ? styles.outline : ''].join(' ')}
                href={href}
                style={style}
                disabled={disabled}
                onClick={onClick}>
                {children}
            </Link>
        );
    }

    return (
        <button type={type} className={[className, styles.Button, primary ? styles.primary : '', secondary ? styles.secondary : ''].join(' ')} style={style} disabled={disabled} onClick={onClick}>
            {children}
        </button>
    );
}
